import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { dateToShortISOString } from '@/utils/dates';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangeFilter',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: [Date, Date]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: [Date, Date];
};

const { t } = useI18n();





const datepickerRef = ref<any>();
const icon = 'calendar-range';

function toggleDatepicker() {
  datepickerRef.value.toggle();
}

const internalValue = computed<[Date, Date]>({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

return { __sfc: true,t, props, emit, datepickerRef, icon, toggleDatepicker, internalValue, dateToShortISOString }
}

})